import { FC } from 'react';
import { DownloadOrdersExport } from 'components/DownloadOrdersExport';
import { Page } from 'layouts/Page';

export const DownloadOrdersExportPage: FC = () => {
	return (
		<Page title="Download Export File – EAS Dashboard">
			<DownloadOrdersExport />
		</Page>
	);
};
